// import anime from 'animejs'
import Timer from '@/core/util/Timer'
// import BrowserUtil from '@/core/util/BrowserUtil'
// import Storage from '@/core/util/Storage'
// import { MyUserType } from '@/Types'
// import { ViewSize } from '@/Const'
import DocumentView from '@/core/view/DocumentView'
// import HorizontalScrollSyncControler from '@/core/controller/HorizontalScrollSyncControler'
import AnchorController from '@/core/controller/AnchorController'
// import MatchMediaDocumentViewDelegate from '@/core/delegate/MatchMediaDocumentViewDelegate'
import { MediaSize } from '@/core/delegate/MatchMediaDocumentViewDelegate'
// import AreaCheckController from '@/core/controller/AreaCheckController'
import InviewController from '@/core/controller/InviewController'
import GalleryCarouselController from '@/controller/GalleryCarouselController'
// import MainCarouselController from '@/controller/MainCarouselController'
import JSScrollController from '@/core/controller/JSScrollController'
// import MovableView from '@/core/view/MovableView'
import StayTopView from '@/core/view/StayTopView'
// import CoverLayoutView from '@/core/view/CoverLayoutView'
// import VerticalPositionViewController from '@/core/controller/VerticalPositionViewController'
// import SPHeaderView from '@/view/SPHeaderView'
import LoadingView from '@/view/LoadingView'
import HeaderView from '@/view/HeaderView'

class MyDocument extends DocumentView {
  // SP用ヘッダー
  // private spHeaderView!: SPHeaderView

  // ヘッダーの上部固定処理
  private headerStayTopView!: StayTopView

  // ローディング
  private loadingView!: LoadingView

  // レスポンシブ状態
  private matchMediaName: 'PC' | 'SP' = 'PC'

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()

    window.onbeforeunload = function () {
      // IE用。ここは空でOKです
    }
    window.onunload = function () {
      // IE以外用。ここは空でOKです
    }

    window.onpageshow = function (event: any) {
      if (event.persisted) {
        const bodys = document.getElementsByTagName('body')
        const body = bodys![0]
        if (body) {
          body.classList.remove('will-leave')
        }
      }
    }
  }

  /**
   * ドキュメントが準備が出来たときに呼び出されます
   */
  public docReady(): void {
    super.docReady()

    // // リンク処理
    // const aTagElms = document.querySelectorAll('a')
    // ;[].slice.call(aTagElms).forEach((item: HTMLElement, index) => {
    //   item.addEventListener('click', (evt: MouseEvent) => {
    //     const href = (evt.currentTarget! as HTMLElement).getAttribute('href')
    //     if (
    //       href &&
    //       href.indexOf(location.pathname) != -1 &&
    //       href.indexOf('#') != -1
    //     ) {
    //       // アンカーリンク処理(同一ページ内)
    //     } else if (href && href.substr(0, 10) == 'items.html') {
    //       // サイト内リンク処理
    //       evt.preventDefault()
    //       this.pageMove(href)
    //     }
    //   })
    // })

    // scroll to top
    const tmpElms = document.querySelectorAll('.btn-scrolltotop')
    if (tmpElms.length) {
      ;(tmpElms[0] as HTMLElement).addEventListener(
        'click',
        (evt: MouseEvent) => {
          evt.preventDefault()
          const scroller = new JSScrollController()
          scroller.to(0, 1200)
        },
      )
    }

    // scroll down
    const tmpElms2 = document.querySelectorAll('.front-scrolldown')
    if (tmpElms2.length) {
      ;(tmpElms2[0] as HTMLElement).addEventListener(
        'click',
        (evt: MouseEvent) => {
          evt.preventDefault()
          const scroller = new JSScrollController()
          const mainElm = document.querySelectorAll('.main')![0]
          if (mainElm) {
            const scrollY = window.scrollY || window.pageYOffset
            const r = mainElm.getBoundingClientRect()
            scroller.to(r.top + scrollY, 1000)
          }
        },
      )
    }

    // // 画面高さをCSSで利用
    // const setFillHeight = () => {
    //   const vh = window.innerHeight
    //   document.documentElement.style.setProperty('--vh', `${vh}px`)
    // }
    // // 画面のサイズ変動があった時に高さを再計算する
    // if (BrowserUtil.isTablet) {
    //   // Tablet端末は、リサイズを無視
    // } else if (BrowserUtil.isMobile) {
    //   // Mobile端末は、リサイズを無視
    // } else {
    //   window.addEventListener('resize', setFillHeight)
    // }
    // // 初期化
    // setFillHeight()

    // // 画面上部で留める要素
    // const tmpElms = document.querySelectorAll('.js-stay-top')
    // ;[].slice.call(tmpElms).forEach((elem: HTMLElement) => {
    //   this.headerStayTopView = new StayTopView(elem)
    //   this.headerStayTopView.init()
    // })

    // //SP,PC の切り替わりをハンドリング
    // const matchMediaDocumentViewDelegate = new MatchMediaDocumentViewDelegate([
    //   {
    //     name: 'SP',
    //     min: 0,
    //     max: 800,
    //     showCount: 0,
    //   },
    //   {
    //     name: 'PC',
    //     min: 800,
    //     max: 9999,
    //     showCount: 0,
    //   },
    // ])
    // matchMediaDocumentViewDelegate.delegate = this
    // matchMediaDocumentViewDelegate.init()

    // const handleBrowserState = (event: any) => {
    //   // do something
    //   if (event == true) {
    //     matchMediaDocumentViewDelegate.forceCallFunction()
    //   }
    // }

    // window.addEventListener('focus', handleBrowserState.bind(this, true))
    // window.addEventListener('blur', handleBrowserState.bind(this, false))

    // カルーセル処理
    const pp = document.querySelectorAll('.person__pics')
    ;[].slice.call(pp).forEach((item: HTMLElement, index) => {
      const ctrler = new GalleryCarouselController(item)
      ctrler.init()
    })

    new HeaderView()
  }

  /**
   * すべての読み込みが完了した際に呼び出されます。
   */
  public docLoadAll(): void {
    super.docLoadAll()

    // start
    this.start()
  }

  /**
   * 開始
   */
  public async start(): Promise<void> {
    await Timer.wait(800)

    // ローディングを非表示
    const tmpElm = document.querySelectorAll('.loadingPanel')![0]
    if (tmpElm) tmpElm.classList.remove('is-show')

    // アンカーリンク
    new AnchorController()

    //In-View処理
    this.watchInView()
  }

  /**
   * InView処理
   */
  watchInView() {
    //
    // inView
    //
    const inviewController = new InviewController()
    inviewController.scale = 0.5

    // すでに表示領域に入り済み
    inviewController.on('onDisplayed', (elem: any) => {
      elem = elem as HTMLElement
      // inViewのclassを外す
      if (elem.classList.contains('inView')) {
        elem.classList.remove('inView')
      }
      elem.classList.forEach((item: string) => {
        if (item.substr(0, 6) == 'inView') {
          elem.classList.remove(item)
        }
      })
      // 中にあるInView要素も反応させる
      if (elem.getAttribute('data-inview-noinnerinview') != 'true') {
        const tmpElms = elem.getElementsByClassName('innerInView')
        ;[].slice.call(tmpElms).forEach((elem: HTMLElement) => {
          elem.classList.remove('innerInView')
        })
      }
    })

    // 新たに表示領域に入った
    inviewController.on('onEnter', (elem: any) => {
      elem = elem as HTMLElement
      elem.classList.add('isInview')
      // 中にあるInView要素も反応させる
      if (elem.getAttribute('data-inview-noinnerinview') != 'true') {
        const tmpElms = elem.getElementsByClassName('innerInView')
        ;[].slice.call(tmpElms).forEach((elem: HTMLElement) => {
          elem.classList.add('isInview')
        })
      }
    })
    const list: HTMLCollection = document.getElementsByClassName('inView')
    Array.prototype.slice.call(list).forEach((elem) => {
      inviewController.add(elem)
    })
    inviewController.init()
  }

  /**
   * SP、PCの切り替え
   */
  // SP
  private async onChangeSizeToSPSize(mediaSize: MediaSize, forceCall: boolean) {
    // console.log('SP')
    // console.log(mediaSize)
    // this.matchMediaName = 'SP'
    // // ビデオを挿入
    // const videoWrapElm = document.getElementById('intro-movie-wrap')
    // if (videoWrapElm) {
    //   const tmpElem = document.getElementById('video-sp')
    //   if (tmpElem) {
    //     if (forceCall) {
    //       videoWrapElm.innerHTML = ''
    //       await Timer.wait(100)
    //     }
    //     videoWrapElm.innerHTML = tmpElem.innerHTML
    //     const videoElm = videoWrapElm.children[0] as HTMLElement
    //     if (videoElm) {
    //       const vWidthStr = videoElm.getAttribute('width')
    //       const vHeightStr = videoElm.getAttribute('height')
    //       const vWidth = parseInt(vWidthStr ? vWidthStr : '0', 10)
    //       const vHeight = parseInt(vHeightStr ? vHeightStr : '0', 10)
    //       if (this.videoCoverLayoutView) this.videoCoverLayoutView.destroy()
    //       this.videoCoverLayoutView = new CoverLayoutView(
    //         videoElm,
    //         vWidth,
    //         vHeight,
    //         'cover',
    //       )
    //       this.videoCoverLayoutView.init()
    //     }
    //   }
    // }
  }
  // PC
  private onChangeSizeToPCSize(mediaSize: MediaSize, forceCall: boolean) {
    // console.log('PC')
    // console.log(mediaSize)
    // this.matchMediaName = 'PC'
    // // ビデオを挿入
    // const videoWrapElm = document.getElementById('intro-movie-wrap')
    // if (videoWrapElm) {
    //   const tmpElem = document.getElementById('video-pc')
    //   if (tmpElem) {
    //     videoWrapElm.innerHTML = tmpElem.innerHTML
    //     const videoElm = videoWrapElm.children[0] as HTMLElement
    //     if (videoElm) {
    //       const vWidthStr = videoElm.getAttribute('width')
    //       const vHeightStr = videoElm.getAttribute('height')
    //       const vWidth = parseInt(vWidthStr ? vWidthStr : '0', 10)
    //       const vHeight = parseInt(vHeightStr ? vHeightStr : '0', 10)
    //       if (this.videoCoverLayoutView) this.videoCoverLayoutView.destroy()
    //       this.videoCoverLayoutView = new CoverLayoutView(
    //         videoElm,
    //         vWidth,
    //         vHeight,
    //         'contain',
    //       )
    //       this.videoCoverLayoutView.init()
    //     }
    //   }
    // }
  }

  /**
   * サイト内ページ移動
   */
  private async pageMove(href: string): Promise<void> {
    const bodys = document.getElementsByTagName('body')
    const body = bodys![0]
    if (body) {
      body.classList.add('will-leave')
      await Timer.wait(400)
    }
    location.href = href
  }
}
new MyDocument()
